<template>
  <div class="topic_box">
    <div class="topic_list">

      <!-- 拖拽示例 -->
      <draggable class="list-group" :list="topicData" group="people" @end="onDragEnd" @change="draggableChange"
        itemKey="name">
        <div class="list-group-item" v-for="(element, index) in topicData" :key="element.topicName">
          <div class="topic_item mb-20 pb-10" style="color: #ffffff;">
            <div class="controlLine" v-if="editeSut">
              <div class="edit" @click="handleEdit(element)">
                <img src="./img/edit.png" alt="">
              </div>
              <a-popconfirm title="确定删除吗？该操作不会撤销" ok-text="是" cancel-text="否" @confirm="handleDel(element)"
                @cancel="handleDelCancel(element)">
                <div class="del">
                  <img src="./img/del.png" alt="">
                </div>
              </a-popconfirm>
            </div>
            <div class="topic_title mb-10">
              {{ index + 1 }}、{{ element.topicName }}
            </div>
            <div class="topic_select pl-20 pr-20">
              <template v-if="element.topicType == 1">
                <div class="flex-row align-center">
                  <!-- <div class="">{{ element.answer ? element.answer : 0 }}</div> -->
                  <div class="flex-1" ref="selectBox">
                    <!-- <a-input-number v-model:value="element.slider_marks" /> -->
                    <a-slider min="1" :max="element.sliderMaxVal" :marks="element.slider_marks" @change="changeForm"
                      :getPopupContainer="() => this.$refs.selectBox" />
                  </div>
                </div>
              </template>
              <template v-if="element.topicType == 2">
                <a-radio-group v-model:value="element.answer" @change="changeForm">
                  <a-radio v-for="ele in element.optionVos" :key="ele.answerId" :value="ele.answerId">{{ ele.option
                    }}</a-radio>
                </a-radio-group>
              </template>
              <template v-if="element.topicType == 3">
                <a-checkbox-group v-model:value="element.answer" @change="changeForm">
                  <a-checkbox v-for="ele in element.optionVos" :key="ele.answerId" :value="ele.answerId">
                    {{ ele.option }}
                  </a-checkbox>
                </a-checkbox-group>
              </template>
              <template v-if="element.topicType == 4">
                <!-- 人体图 -->

                <Body @selectBody="selectBody" :selectItemS="selectItemS" />
              </template>
              <template v-if="element.topicType == 5">
                <a-textarea v-model:value="element.answer" :placeholder="element.placeholder" :rows="4"
                  @change="changeForm" />
              </template>
            </div>
          </div>
        </div>
        <!-- </template> -->
      </draggable>

    </div>

  </div>
</template>

<script>
import Body from "./body.vue";
import draggable from 'vuedraggable' //目前使用的是vue3安装使用的
export default {
  components: {
    Body,
    draggable
  },
  data() {
    return {
      show: false,
      modalTitle: '',
      ids: null,
      slider_marks: {
        1: "很轻松",
        10: "极限",
      },
    }
  },
  props: {
    topicData: {
      type: Array,
      default: () => [],
    },
    questionListSolid: {
      type: Array,
      default: () => [],
    },
    editeSut: {
      type: String,
    }
  },
  computed: {
    selectItemS() {
      return this.topicData.filter((element) => element.topicType === 4);
    },
  },
  watch: {

  },
  methods: {
    getPopupContainer() {
      return document.getElementById('quesMain'); // 指定下拉框的容器为body元素
    },

    // 拖拽-start
    draggableChange(e) {
      // console.log(e)
      // this.$emit("draggableChange", e)
    },

    onDragEnd(e) {
      // console.log(e)
    },
    // 拖拽-end

    //监听做题数量
    changeForm(e) {
      this.$emit("change", this.topicData);
    },

    // 人体渲染
    selectBody(obj) {
      this.topicData.map((element) => {
        if (element.topicType == 4) {
          element.answer = obj;
        }
      });
      this.$emit("change", this.topicData);
    },

    // 删除单个问题
    handleDel(e) {
      this.$emit("delModal", e);
    },

    // 编辑单个问题
    handleEdit(e) {
      this.$emit("showModal", e);
    },

  },
  created() { },
};
</script>

<style lang="less" scoped>
.ant-radio-wrapper-disabled {
  ::v-deep span {
    // color: #fff !important
  }
}

.ant-radio-group {
  display: flex;
  align-items: center;

  .ant-radio-wrapper {
    margin-right: 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
}

.ant-checkbox-group {
  display: flex;
  align-items: center;

  .ant-checkbox-wrapper {
    margin-right: 10px;
    font-size: 16px;
    display: flex;
    align-items: center;

    .ant-checkbox+span {
      height: 16px;
      line-height: 16px;
    }
  }
}

::v-deep .ant-radio-disabled .ant-radio-inner::after {
  background: #1890ff !important;
}

.slider_num {
  font-size: 14px;
  color: var(--text-color);
  width: 32px;
  height: 32px;
  background: linear-gradient(129deg, #419bf2 5%, #2b6df9 96%);
  border-radius: 4px;
  margin-right: 16px;
  text-align: center;
  line-height: 32px;
  margin-top: -20px;
}

::v-deep.ant-checkbox-wrapper {
  // color: #ffffff;
}

.topic_item {
  // color: #fff;
  position: relative;

  .topic_title {
    font-size: 14px;
    // font-weight: bold;
  }
}

:deep(.ant-slider-mark-text) {
  // color: #fff;
  margin-top: 4px;
}

:deep(.ant-slider-mark) {
  font-size: 14px;
}

.topic_select {
  position: relative;
  padding-right: 0;
  font-size: 14px;
  color: #fff;

  label {
    color: #fff;
  }

  .flex-row {
    &>div {
      margin-top: -12px;
    }

    .flex-1 {
      margin-top: 0;
      margin-left: 0;
      width: 100%;
    }
  }
}

.controlLine {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;

  div {
    border: 1px solid #1890FF;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    cursor: pointer;

    img {
      width: 12px;
    }

    &:hover {
      background-color: #fff;
      border-color: #fff;
    }
  }

  div.del {
    border: 1px solid #F21753;

    &:hover {
      background-color: #fff;
      border-color: #fff;
    }
  }
}

.topic_list {
  .topic_title {
    color: #fff;
  }
}

::v-deep .ant-slider-rail {
  background-color: #5E668D;
}
</style>